// src/config/routes.js
import ProductPage from '../pages/ProductPage';
import ProfilePage from '../pages/ProfilePage';
import AttestationPage from '../pages/attestation/AttestationPage';
import UserCreateForm from '../pages/users/UserCreateForm';
import TransferForm from '../pages/attestation/TransferForm';
import SettingsPage from '../pages/settings/SettingsPage';
import EntityPage from '../pages/entities/EntityPage';

import Dashboard from '../pages/Dashboard';
import UsersPage from '../pages/UsersPage';
import UserForm from '../components/users/UserForm';
import UserDetails from '../components/users/UserDetails';
import RolesPage from '../pages/roles/RolePage';
import RoleForm from '../components/roles/RoleForm';
import RoleDetails from '../components/roles/RoleDetails';
import PermissionsPage from '../pages/roles/PermissionsPage';
import PermissionForm from '../components/permissions/PermissionForm';
import PermissionList from '../components/permissions/PermissionsList';
import PermissionDetails from '../components/permissions/PermissionDetails';
import GarageList from '../components/garages/GarageList';
import GarageForm from '../components/garages/GarageForm';
import GarageDetail from '../components/garages/GarageDetail';
import EntityForm from '../components/entities/EntityForm';
import EntityDetails from '../components/entities/EntityDetails';
import AgencyList from '../components/agencies/AgencyList';
import AgencyForm from '../components/agencies/AgencyForm';
import AgencyDetails from '../components/agencies/AgencyDetails';
import ServiceList from '../components/services/ServiceList';
import ServiceForm from '../components/services/ServiceForm';
import ServiceDetail from '../components/services/ServiceDetail';
import OpeningHoursPage from '../components/agencies/OpeningHoursPage';
import AttestationList from '../components/attestations/AttestationList';
import AttestationDetails from '../components/attestations/AttestationDetails';
import AttestationForm from '../components/attestations/AttestationForm';
import AttestationDocumentsPage from '../components/attestations/AttestationDocumentsPage';
import BlogPostList from '../components/blog/BlogPostList';
import BlogPostForm from '../components/blog/BlogPostForm';
import BlogPostDetails from '../components/blog/BlogPostDetails';
import TagList from '../components/tags/TagList';
import CategoryList from '../components/categories/CategoryList';
import CategoryForm from '../components/categories/CategoryForm';
import CategoryDetails from '../components/categories/CategoryDetails';
import TagDetails from '../components/tags/TagDetails';
import TagForm from '../components/tags/TagForm';
import BlogPostComments from '../components/blog/BlogPostComments';
import FAQList from '../components/faqs/FAQList';
import FAQForm from '../components/faqs/FAQForm';
import FAQDetails from '../components/faqs/FAQDetails';
import FAQFeedbackPage from '../components/faqs/FAQFeedbackPage';
import ProductList from '../components/products/ProductList';
import ProductForm from '../components/products/ProductForm';
import ProductDetails from '../components/products/ProductDetails';
import ProductFeatures from '../components/products/ProductFeatures';
import ProductFeatureForm from '../components/products/ProductFeatureForm';
import ProductBenefits from '../components/products/ProductBenefits';
import ProductBenefitForm from '../components/products/ProductBenefitForm';
import ProductPricing from '../components/products/ProductPricing';
import ProductPricingForm from '../components/products/ProductPricingForm';
import ProductEligibility from '../components/products/ProductEligibility';
import ProductEligibilityForm from '../components/products/ProductEligibilityForm';
import ProductExclusions from '../components/products/ProductExclusions';
import ProductExclusionForm from '../components/products/ProductExclusionForm';

export const protectedRoutes = [
  { path: "/", element: <Dashboard /> },
  { path: "/products", element: <ProductPage /> },
  { path: "/products/attestation", element: <AttestationPage /> },
  { path: "/products/attestation/:create", element: <TransferForm /> },
  //{ path: "/admin/users", element: <UserPage /> },
  //{ path: "/admin/roles", element: <RolePage /> },
  { path: "/admin/add-user", element: <UserCreateForm /> },
  { path: "/admin/settings", element: <SettingsPage /> },
  { path: "/admin/profile", element: <ProfilePage /> },
  { path: "/admin/entities", element: <EntityPage /> },
  { path: "/admin/entities/form", element: <EntityForm /> },
  { path: "/admin/entities/:id/details", element: <EntityDetails /> },
  { path: "/admin/entities/:id/edit", element: <EntityForm /> },

  { path: "/admin/dashboard", element: <Dashboard /> },
  { path: "/admin/users", element: <UsersPage /> },
  { path: "/admin/users/form", element: <UserForm /> },
  { path: "/admin/users/details/:id", element: <UserDetails /> },
  { path: "/admin/users/:id/edit", element: <UserForm /> },
  { path: "/admin/roles", element: <RolesPage /> },
  { path: "/admin/roles/form", element: <RoleForm /> },
  { path: "/admin/roles/:id/edit", element: <RoleForm /> },
  { path: "/admin/roles/:id/details", element: <RoleDetails /> },
  { path: "/admin/roles/:id/permissions", element: <PermissionsPage /> },

  { path: "/admin/permissions/form", element: <PermissionForm /> },
  { path: "/admin/permissions/:id/edit", element: <PermissionForm /> },
  { path: "/admin/permissions/:id/details", element: <PermissionDetails /> },
  { path: "/admin/permissions", element: <PermissionList /> },

  // garage routes
  { path: "/admin/garages", element: <GarageList /> },
  { path: "/admin/garages/form", element: <GarageForm /> },
  { path: "/admin/garages/:id/edit", element: <GarageForm /> },
  { path: "/admin/garages/:id/details", element: <GarageDetail /> },

  //agency routes
  { path: "/admin/agencies", element: <AgencyList /> },
  { path: "/admin/agencies/form", element: <AgencyForm /> },
  { path: "/admin/agencies/:id/edit", element: <AgencyForm /> },
  { path: "/admin/agencies/:id/details", element: <AgencyDetails /> },
  { path: "/admin/agencies/:id/services", element: <ServiceList /> },
  { path: "/admin/agencies/:id/hours", element: <OpeningHoursPage /> },


  // service routes
  { path: "/admin/services/form", element: <ServiceForm /> },
  { path: "/admin/services/:id/edit", element: <ServiceForm /> },
  { path: "/admin/services/:id/details", element: <ServiceDetail /> },

  // attestation routes
  { path: "/admin/attestations", element: <AttestationList /> },
  { path: "/admin/attestations/form", element: <AttestationForm /> },
  { path: "/admin/attestations/:id/edit", element: <AttestationForm /> },
  { path: "/admin/attestations/:id/details", element: <AttestationDetails /> },
  { path: "/admin/attestations/:id/documents", element: <AttestationDocumentsPage /> },

  // blog post routes
  { path: "/admin/blog-posts", element: <BlogPostList /> },
  { path: "/admin/blog-posts/form", element: <BlogPostForm /> },
  { path: "/admin/blog-posts/:id/edit", element: <BlogPostForm /> },
  { path: "/admin/blog-posts/:id/details", element: <BlogPostDetails /> },
  { path: "/admin/blog-posts/:id/comments", element: <BlogPostComments /> },

  //tag routes
  { path: "/admin/tags", element: <TagList /> },
  { path: "/admin/tags/form", element: <TagForm /> },
  { path: "/admin/tags/:id/edit", element: <TagForm /> },
  { path: "/admin/tags/:id/details", element: <TagDetails /> },

  //category routes
  { path: "/admin/categories", element: <CategoryList /> },
  { path: "/admin/categories/form", element: <CategoryForm /> },
  { path: "/admin/categories/:id/edit", element: <CategoryForm /> },
  { path: "/admin/categories/:id/details", element: <CategoryDetails /> },

  //faq routes
  { path: "/admin/faqs", element: <FAQList /> },
  { path: "/admin/faqs/form", element: <FAQForm /> },
  { path: "/admin/faqs/:id/edit", element: <FAQForm /> },
  { path: "/admin/faqs/:id/details", element: <FAQDetails /> },
  { path: "/admin/faqs/:id/feedback", element: <FAQFeedbackPage /> },

  // products routes
  { path: "/admin/products", element: <ProductList /> },
  { path: "/admin/products/form", element: <ProductForm /> },
  { path: "/admin/products/:id/edit", element: <ProductForm /> },
  { path: "/admin/products/:id/details", element: <ProductDetails /> },

  { path: "/admin/products/:id/features", element: <ProductFeatures /> },
  { path: "/admin/products/:id/features/add", element: <ProductFeatureForm /> },
  { path: "/admin/products/:id/features/:featureId/edit", element: <ProductFeatureForm /> },
  { path: "/admin/products/:id/benefits", element: <ProductBenefits /> },
  { path: "/admin/products/:id/benefits/add", element: <ProductBenefitForm /> },
  { path: "/admin/products/:id/benefits/:benefitId/edit", element: <ProductBenefitForm /> },
  { path: "/admin/products/:id/pricing", element: <ProductPricing /> },
  { path: "/admin/products/:id/pricing/add", element: <ProductPricingForm /> },
  { path: "/admin/products/:id/pricing/:tierId/edit", element: <ProductPricingForm /> },

  { path: "/admin/products/:id/eligibility", element: <ProductEligibility /> },
  { path: "/admin/products/:id/eligibility/add", element: <ProductEligibilityForm /> },
  { path: "/admin/products/:id/eligibility/:eligibilityId/edit", element: <ProductEligibilityForm /> },

  { path: "/admin/products/:id/exclusions", element: <ProductExclusions /> },
  { path: "/admin/products/:id/exclusions/add", element: <ProductExclusionForm /> },
  { path: "/admin/products/:id/exclusions/:exclusionId/edit", element: <ProductExclusionForm /> },
];